// extracted by mini-css-extract-plugin
module.exports = {"mobile_comment":"icon_mobile_comment__8_KvU","icon":"icon_icon__2A1ga"};